'use client'

import { Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import BusinessAccountsFaq from '../../../components/BusinessAccountsFaq/BusinessAccountsFaq'

const Faq = () => {
  const translate = useTranslate('business.homepage')

  return (
    <div className="content-block u-ui-padding-top-large@portables">
      <div className="content-block__content u-ui-padding-bottom-x4-large@desktops u-ui-padding-bottom-x-large@portables">
        <div className="content-block__heading u-ui-padding-vertical-x2-large@desktops u-ui-padding-top-large@portables u-ui-padding-bottom-x-large@portables">
          <Text as="span">
            <span className="c-text--responsive-small-heading">{translate('faq.title')}</span>
          </Text>
        </div>
        <BusinessAccountsFaq />
      </div>
    </div>
  )
}

export default Faq
